import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Typography,
  PLATFORM_THEME_COLORS,
  Form,
  TextInput,
  TextAreaInput,
  Button,
  ICONS,
  Icon,
  SelectInput,
} from '@thinknet-gmbh/platform-common-ui';

import { BooleanSelectInput } from 'src/pages/employee/components/boolean-select-input';
import {
  DeleteContainer,
  FormListWrapper,
} from 'src/pages/employee/sub-pages/create-employee/create-employee.styles';

import { getEducationAndSkillsData } from './educations-and-skills.constants';
import { MainWrapper, EducationsWrapper } from './educations-and-skills.styles';


const EducationsAndSkills = ({ isEdit }: { isEdit?: boolean }) => {
  const { t } = useTranslation(['common', 'employee', 'products']);

  const EDUCATIONS_AND_SKILLS_DATA = getEducationAndSkillsData(t);

  return (
    <MainWrapper>
      {!isEdit && (
        <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
          {t('employee:educationsAndSkills.labels.headerTitle')}
        </Typography>
      )}
      <div>
        <EducationsWrapper>
          {EDUCATIONS_AND_SKILLS_DATA.map(({ groupName, groupItems }) => (
            <div key={`${groupName}`}>
              <Typography
                className={'education-title-label'}
                weight="bold"
                fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}
              >
                {t(`employee:educationsAndSkills.labels.${groupName}`)}
              </Typography>
              {groupItems.map(
                ({ titleFieldName, descriptionFieldName, inputType, selectOptions }) => (
                  <Fragment key={titleFieldName}>
                    {inputType === 'select' ? (
                      <Form.Item
                        name={['educationAndSkills', titleFieldName]}
                        label={t(`employee:educationsAndSkills.labels.${titleFieldName}`)}
                      >
                        {groupName === 'driversLicenses' ? (
                          <BooleanSelectInput t={t} />
                        ) : (
                          <SelectInput
                            placeholder={t(`employee:educationsAndSkills.placeholders.${titleFieldName}`)}
                          >
                            {selectOptions?.map(el => (
                              <SelectInput.Option value={el?.value} key={el.value}>
                                {el?.label}
                              </SelectInput.Option>
                            ))}
                          </SelectInput>
                        )}
                      </Form.Item>
                    ) : (
                      <Form.Item
                        name={['educationAndSkills', titleFieldName]}
                        label={t(`employee:educationsAndSkills.labels.${titleFieldName}`)}
                      >
                        <TextInput maxLength={50} placeholder={t(`employee:educationsAndSkills.placeholders.${titleFieldName}`)} />
                      </Form.Item>
                    )}
                    {descriptionFieldName && (
                      <Form.Item
                        name={['educationAndSkills', descriptionFieldName]}
                        label={t('common:labels.description')}
                      >
                        <TextAreaInput
                          showCount
                          maxLength={500}
                          placeholder={t(
                            'products:planList.createPlan.placeholders.writeDescription'
                          )}
                        />
                      </Form.Item>
                    )}
                  </Fragment>
                )
              )}
            </div>
          ))}
        </EducationsWrapper>
        <Form.List name={['educationAndSkills', 'skills']} initialValue={isEdit ? undefined : [{}]}>
          {(fields, { add, remove }) => (
            <FormListWrapper isIcon={fields.length > 1}>
              <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
                {t('employee:educationsAndSkills.labels.skills')}
              </Typography>
              <div>
                {fields.map(field => (
                  <div key={field.key}>
                    <DeleteContainer isIcon={fields.length > 1}>
                      <Form.Item
                        name={[field.name, 'name']}
                        label={t('employee:educationsAndSkills.labels.skillsName')}
                      >
                        <TextInput maxLength={50} placeholder={t('employee:labels.startTyping')} />
                      </Form.Item>
                      {fields.length > 1 && (
                        <Icon
                          icon={ICONS.trash}
                          rightMargin={false}
                          color={PLATFORM_THEME_COLORS.tone.red}
                          size={22}
                          onClick={() => remove(field.name)}
                        />
                      )}
                    </DeleteContainer>
                    <Form.Item
                      name={[field.name, 'description']}
                      label={t('common:labels.description')}
                    >
                      <TextAreaInput
                        showCount
                        maxLength={500}
                        placeholder={t(
                          'products:planList.createPlan.placeholders.writeDescription'
                        )}
                      />
                    </Form.Item>
                  </div>
                ))}
              </div>
              <Button
                type="text"
                icon={ICONS.plus}
                iconColor={PLATFORM_THEME_COLORS.primary.blue}
                onClick={() => add()}
              >
                {t('employee:educationsAndSkills.buttons.addNewSkill')}
              </Button>
            </FormListWrapper>
          )}
        </Form.List>
      </div>
    </MainWrapper>
  );
};

export default EducationsAndSkills;
